import {
  HOPE,
  FEAR,
  HOPE_DIE,
  FEAR_DIE,
} from '../../character/content/templates';

export default function Overview() {
  return (
    <>
      <div className="mechanics-overview-card mechanics-overview-card--gold">
        <h3>The Golden Rule</h3>
        <p>The most important rule of Daggerheart is to make the game your own. Prioritize <strong>rulings over rules</strong>, when in doubt, the GM makes a ruling that aligns with the narrative.</p>
      </div>
      <div className="mechanics-overview-card">
        <h3>Action Roll at a Glance</h3>
        <div className="mechanics-steps">
          <div className="mechanics-step"><div className="mechanics-step__label">1. Roll</div><div className="mechanics-step__text">Roll {HOPE_DIE} + {FEAR_DIE} (2d12)</div></div>
          <div className="mechanics-step"><div className="mechanics-step__label">2. Add Modifier</div><div className="mechanics-step__text">Add relevant trait modifier</div></div>
          <div className="mechanics-step"><div className="mechanics-step__label">3. Compare</div><div className="mechanics-step__text">Meet or beat the Difficulty</div></div>
          <div className="mechanics-step"><div className="mechanics-step__label">4. Apply</div><div className="mechanics-step__text">Success/fail + {HOPE} or {FEAR} token</div></div>
        </div>
        <div className="mechanics-dice-row">
          <div className="mechanics-dice-box mechanics-dice-box--hope">
            <div className="mechanics-dice-box__title"><strong>Hope</strong> Die Highest</div>
            <div className="mechanics-dice-box__text">Player gains a {HOPE} token</div>
          </div>
          <div className="mechanics-dice-box mechanics-dice-box--fear">
            <div className="mechanics-dice-box__title"><strong>Fear</strong> Die Highest</div>
            <div className="mechanics-dice-box__text">GM gains a {FEAR} token</div>
          </div>
        </div>
      </div>
    </>
  );
}
